module.exports = __webpack_public_path__ + "img/img_61290_0_9.8e80cf67.png";